import React from 'react';
import { Helmet } from 'react-helmet-async';

const LandingMetaTags = () => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>VoiceInk - Best Dictation App for macOS</title>
      <meta name="description" content="VoiceInk is a privacy-focused dictation app for macOS with local transcription, AI enhancement, custom modes, and open-source transparency." />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://tryvoiceink.com/" />
      <meta property="og:title" content="VoiceInk - Best Dictation App for macOS" />
      <meta property="og:description" content="Local AI dictation for macOS with offline transcription, privacy-first workflows, custom modes, and lifetime pricing." />
      <meta property="og:image" content="https://tryvoiceink.com/preview.png" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="VoiceInk" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@tryvoiceink" />
      <meta name="twitter:creator" content="@JoshiPax" />
      <meta name="twitter:title" content="VoiceInk - Best Dictation App for macOS" />
      <meta name="twitter:description" content="Private macOS dictation with local AI, custom modes, and open-source transparency." />
      <meta name="twitter:image" content="https://tryvoiceink.com/preview.png" />
      <meta name="twitter:image:alt" content="VoiceInk - Transform Speech to Text Instantly on Mac" />

      {/* Additional SEO tags */}
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href="https://tryvoiceink.com/" />

      {/* Language and locale */}
      <html lang="en" />

      {/* Additional SEO meta tags */}
      <meta name="application-name" content="VoiceInk" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black" />
      <meta name="apple-mobile-web-app-title" content="VoiceInk" />
    </Helmet>
  );
};

export default LandingMetaTags; 
